module.exports = __webpack_public_path__ + "img/toast.b53512c2.png";